<div>
  <div>
    A recent change in your recovery point has invalidated the current subnet-to-AZ mapping in the recovery environment.
    {{ uiService.productName }} needs to update the following recovery subnet configurations in order to restore all
    resources properly. Any resources that are not managed by {{ uiService.productName }} will need to be removed from
    these subnets prior to applying these changes.
  </div>
  <div class="padding-top" style="width: 100%">
    <table style="width: 100%">
      <thead>
        <tr>
          <th>Primary Subnet ID</th>
          <th>Recovery Subnet ID</th>
          <th>Current Recovery AZ</th>
          <th>New Recovery AZ</th>
        </tr>
      </thead>
      <tbody>
        @for (move of issue.subnetMoves; track move) {
          <tr>
            <td>{{ move.srcSubnetId }}</td>
            <td>{{ move.tgtSubnetId }} (will be replaced)</td>
            <td>{{ move.oldAz }}</td>
            <td>{{ move.newAz }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="flex-center-row control-header">
    <div class="spacer"></div>
    <button
      type="button"
      busy-button
      [busy]="disableRetry"
      [disabled]="disableRetry"
      class="arpio-button small-button"
      (click)="launchRestoreToTryAgain()"
    >
      Retry and Remap
    </button>
  </div>
</div>
